module.exports = __webpack_public_path__ + "static/media/details.4b407cb4.png";